module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-Light-22e7a8cd73cf8be66d0e5a3b83bb10af.ttf";